/**
 * Created by roi on 29/05/17.
 */
import React, { Component } from 'react';
import L from 'leaflet';
import PropTypes from 'prop-types';

import { generarCapaBase } from '../commons/mapa';

class LocalitzacioDetallMapa extends Component {
	componentDidMount() {
		const coordenades = this.props.coordenades;

		var coordenadesEstacioLatLong = L.latLng(coordenades.latitud, coordenades.longitud);
		var layer = generarCapaBase();
		this.mapa = L.map(this.container, {
			maxZoom: 13,
			minZoom: 8,
			dimX: '000',
			dimY: '000',
			zoom: 12,
			maxBounds: [[43, -0.06], [40.37, 3.57]],
			center: coordenadesEstacioLatLong,
			layers: [layer],
			attributionControl: false
		});

		//Es crea el punt on esta ubicada l'estació.
		L.marker(coordenadesEstacioLatLong).addTo(this.mapa);
	}

	componentWillUnmount() {
		this.mapa.remove();
	}

	render() {
		const { classeCss } = this.props;
		return <div className={classeCss} ref={(ref) => (this.container = ref)}></div>;
	}
}

LocalitzacioDetallMapa.propTypes = {
	coordenades: PropTypes.object,
	classeCss: PropTypes.string
};

export default LocalitzacioDetallMapa;



// WEBPACK FOOTER //
// ./src/components/commons/localitzacioDetallMapa.js